import service from '@/middleware'

const alertEventApi = {
    /**
     * Para obtener los datos de las cosas para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} enterprises
     * @param {*} types
     * @param {*} typesEvents
     */
    async findAll(pageSize, pageNumber, enterprises, types, typesEvents) {
        const url = pageSize != null && pageNumber != null
            ? `/api/alert-event/abm-all?pageSize=${pageSize}&pageNumber=${pageNumber}`
            : `/api/alert-event/abm-all`
        const user = await service.http.post(url, { enterprises, types, typesEvents })
        return user
    },
    /**
     * Para obtener los datos de las cosas para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} enterprises
     * @param {*} types
     * @param {*} typesEvents
     */
     async findAllSuccessfulAlerts(pageSize, pageNumber, userIds, eventIds, thingIds, key) {
        const url = pageSize != null && pageNumber != null
            ? `/api/alert-event/success-alerts?pageSize=${pageSize}&pageNumber=${pageNumber}`
            : `/api/alert-event/success-alerts`
        return await service.http.post(url, { userIds, eventIds, thingIds, key })
    },
    async findAlertsByKey(key) {
        const user = await service.http.get(`/api/alert-event/get-by-key/${key}`)
        return user.data
    },
    /**
     * Para obtener el total de cosas de la collection para el paginador de la tabla del ABM
     * @param {*} enterprises
     * @param {*} types
     * @param {*} typesEvents
     */
    async getTotalCount (enterprises, types, typesEvents) {
        const result = await service.http.post(`/api/alert-event/abm-total`, { enterprises, types, typesEvents })
        return result
    },
    /**
     * Para crear una nueva cosa
     * @param {*} alertEvent
     */
    async create (alertEvent) {
        const result = await service.http.post(`/api/alert-event/create`, alertEvent)
        return result
    },
    /**
     * Para actualizar una cosa
     * @param {*} alertEvent
     */
    async update (alertEvent) {
        const result = await service.http.put(`/api/alert-event/update`, alertEvent)
        return result
    },
    /**
     * Para eliminar una cosa
     * @param {*} id
     */
    async delete (id) {
        const result = await service.http.delete(`/api/alert-event/${id}`)
        return result
    },
    /**
     * Para elminación múltiple
     * @param {*} ids
     */
    async multipleDelete (ids) {
        const result = await service.http.put(`/api/alert-event/multiple-delete`, ids)
        return result
    },
    /**
     * Devuelve los datos de una cosa para el dialog de actualización
     * @param {*} id
     */
    async getAlertEvent(id) {
        const result = await service.http.get(`/api/alert-event/one/${id}`)
        return result
    },
}

export default alertEventApi
